
export class ValidationConstants {
    // regex
    public static startEndWithAlphaNumericValidator: RegExp = /^[A-Za-z0-9]$|^[A-Za-z0-9].*[A-Za-z0-9]$/;
    public static startEndWithAlphaNumericUnderscoreValidator: RegExp = /^[_A-Za-z0-9]$|^[_A-Za-z0-9].*[_A-Za-z0-9]$/;
    public static startWithAlphaNumericUnderscoreValidator: RegExp = /^[_A-Za-z0-9]/;
    public static alphanumericDash: RegExp = /^[-A-Za-z0-9]+$/;
    public static alphanumericUnderscore: RegExp = /^[_A-Za-z0-9]+$/;
    public static noDashNameValidator: RegExp = /^[\s_A-Za-z0-9]+$/;
    public static noSlashFolderNameValidator: RegExp = /^[^\/]*$/; // Folder name can't contain '/'
    public static noHtmlFolderNameValidator: RegExp = /^[^<>&\"\']*$/; // Folder name can't contain html
    public static noTrailingSpaceValidator: RegExp = /\S+$/;
    public static nonEmptyNameValidator: RegExp = /\S+/; // Non whitespace only
    public static allSupportedCharValidator: RegExp = /^[\s-_A-Za-z0-9]+$/;
    public static factoryEntityNameLengthValidator: RegExp = /^.{1,140}$/; // only check for string length, not content
    public static datasetNameMinLengthValidator: RegExp = /^.{2,}$/;
    public static activityNameLengthValidator: RegExp = /^.{1,55}$/;
    public static alphanumericUnderscoreValidator: RegExp = /^[_A-Za-z0-9]+$/;
    public static factoryEntityNameValidator: RegExp = /^([_A-Za-z0-9]|([_A-Za-z0-9][\s-_A-Za-z0-9]{0,138}[_A-Za-z0-9]))$/;
    public static factoryEntityNoSpaceNameValidator: RegExp = /^([_A-Za-z0-9]|([_A-Za-z0-9][-_A-Za-z0-9]{0,138}[_A-Za-z0-9]))$/;
    public static strictlyNoSpaceNameValidator: RegExp = /^[\S]+$/;
    public static datasetNameValidator: RegExp = /^([A-Za-z0-9][_A-Za-z0-9]{0,138}[A-Za-z0-9])$/;
    public static airflowEntitySubTypeValidator: RegExp = /\b(?:DAG|Plugin|Operator|Hook|Sensor)\b/;
    public static emailValidator: RegExp
        = /^((^|([;][ ]*))(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))+$/;
    /**
     *  fqdnValidator is not supported on safari, thus cannot create its literal regex
     *  we have to create it explicitly on demand
     */
    public static fqdnValidator: string = '(?=^.{1,254}$)(^(?:(?!\\d+\\.|-)[a-zA-Z0-9_\\-]{1,63}(?<!-)\\.?)+(?:[a-zA-Z0-9]{1,})$)';
    public static gitBlockedNamesValidator: RegExp = /^(?!master$|model$|tempdb$|distributor$|msdb$).*/i;

    // numbers
    public static maxActivityNameLength: number = 55;
    public static maxEntityNameLength: number = 140;
    public static maxEntityNamePrefixLength: number = 120;
    public static minDatasetNameLength: number = 2;
    public static dataTypeLengthMaxlimit: number = 8000;
}
